// Main entry point
import 'babel-polyfill';
import Vue from 'vue';
import VueGtag from 'vue-gtag';
import vuetify from './plugins/vuetify'; // Imports and 'uses' vuetify in project
import App from './App.vue';
import router from './router';
import store from './store/index.js';
import envService from './services/shared/environmentService.js';
import analytics from '@/services/shared/analyticsService.js';

import axios from 'axios';

axios.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      // Prevent endless redirects
      if (response.url !== undefined) {
        if (response.url.includes('signin')) {
          return Promise.reject(response);
        }
      }
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

const finishSetup = async () => {
  // if user still has cookie, try to renew it, else prompt a login
  await store.dispatch('auth/autoRenew');

  var env = envService.getEnvironment();
  if (env === 'Production') {
    Vue.use(VueGtag, {
      config: {
        id: 'UA-25199945-10'
      }
    });
  } else {
    Vue.use(VueGtag, {
      config: {
        id: 'UA-165113214-1'
      }
    });
  }

  var app = new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
  });
  app.$mount('#app');

  // Configure mapping of custom dimensions
  // These must first be created in the admin section of the analytics site
  analytics.customMap(app.$gtag, {
    dimension1: 'agencyId',
    dimension2: 'userInitials'
  });

  return app;
};

var env = envService.getEnvironment();
localStorage.setItem('environment', env);

finishSetup();
